import React from 'react'
import ScrollWrap from '../components/ScrollWrap'
import Navbar from '../components/Navbar'
import MainWrap from '../components/MainWrap'
import ContactFormWrap from '../components/ContactFormWrap'
import Overlay from '../components/Overlay'
import SlickSlider2 from '../components/SlickSlider2'
import { SlickBusinessData } from '../data/SlickSliderData'
import FundamentalCourses from '../components/FundamentalCourses'
import { FundamentalBusinessData } from '../data/FundamentalCoursesData'
import CounterArea from '../components/CounterArea'
import Enroll from '../components/Enroll'
import { EnrollData4 } from '../data/EnrollData'
import RelatedCourses from '../components/RelatedCourses'
import Footer from '../components/Footer'
import { CounterData2 } from '../data/CounterData'
import ContactAnchor from '../components/ContactAnchor'
import LoginAnchor from '../components/LoginAnchor'

export default function BusinessModules() {
    return (
        <>
            <ContactAnchor />
            <LoginAnchor />
            <ScrollWrap />
            <Navbar />
            <MainWrap />
            <ContactFormWrap />
            <Overlay />
            <SlickSlider2 data={SlickBusinessData}/>
            <FundamentalCourses data={FundamentalBusinessData}/>
            <CounterArea data={CounterData2}/>
            <Enroll data={EnrollData4}/>
            <RelatedCourses />
            <Footer />
        </>
    )
}
